/* GW v2 — bundle builder for the "2 POLO FREE ZIP" automatic BXGY discount.
   Slot 0..N-1 are polos, the last slot is the free zip. Everything it needs comes from the
   JSON blob and data-* attributes the section renders (mockup discipline rule 1) — there are no
   product constants in here, so the pools can change in Shopify without touching this file.
   The form is a real POST with items[N][id] inputs; this only enhances it. */
(function () {
  'use strict';
  var root = document.querySelector('[data-gw-bundle]');
  if (!root) { return; }

  var blob = root.querySelector('[data-gw-bundle-data]');
  var DATA;
  try { DATA = JSON.parse(blob.textContent); } catch (e) { return; }

  var NEED = parseInt(root.getAttribute('data-gw-need'), 10) || 2;
  var ADD_URL = root.getAttribute('data-gw-cart-add') || '/cart/add';
  var CART_URL = root.getAttribute('data-gw-cart-url') || '/cart';
  var TOTAL_SLOTS = NEED + 1;

  var form = root.querySelector('[data-gw-bundle-form]');
  var slotsEl = root.querySelector('[data-gw-slots]');
  var submit = root.querySelector('[data-gw-bundle-submit]');
  var msg = root.querySelector('[data-gw-bundle-msg]');
  var sec = root.closest('section') || root;

  function setting(name, fallback) {
    var v = root.getAttribute('data-gw-' + name);
    return v === null || v === '' ? fallback : v;
  }
  /* Every shopper-facing string comes from the section, so switching what the offer gives away
     (zip -> polo, and whatever comes next) is a settings change, not a code change. */
  var COPY = {
    start: root.querySelector('[data-gw-meter-copy]').textContent.trim(),
    mid: setting('meter-mid', 'PICK YOUR FREE ITEM'),
    done: setting('meter-done', 'FREE ITEM UNLOCKED'),
    freeLabel: setting('free-label', 'YOUR FREE ITEM'),
    freeShort: setting('free-short', 'Free item'),
    ctaIncomplete: submit.textContent.trim(),
    ctaReady: setting('cta-ready', 'ADD BUNDLE TO CART'),
    tiers: setting('tier-labels', '').split(',').map(function (t) { return t.trim(); }).filter(Boolean)
  };

  /* Swipeable photos (per-section checkbox): a card with several product images gets a snap strip
     plus small dots. The dots are the only affordance — the operator asked for "a small, slight
     thing" telling people they can swipe, not a banner. */
  var SWIPE = setting('swipe', 'false') === 'true';

  function mediaHtml(p) {
    var imgs = SWIPE && p.images && p.images.length > 1 ? p.images : (p.image ? [p.image] : []);
    if (imgs.length < 2) {
      return imgs.length ? '<img src="' + esc(imgs[0]) + '" width="200" height="250" loading="lazy" alt="' + esc(p.title) + '">' : '';
    }
    return '<span class="gw-pick__track" data-gw-track>' + imgs.map(function (src, k) {
      return '<img src="' + esc(src) + '" width="200" height="250" loading="lazy" alt="' + esc(p.title) + (k ? ' photo ' + (k + 1) : '') + '">';
    }).join('') + '</span>' +
      '<span class="gw-pick__dots" aria-hidden="true">' + imgs.map(function (_, k) {
        return '<i data-gw-dot="' + k + '"' + (k ? '' : ' class="is-on"') + '></i>';
      }).join('') + '</span>';
  }

  /* one entry per slot: {handle, variantId, size} */
  var picks = new Array(TOTAL_SLOTS).fill(null);

  function pool(i) { return i < NEED ? DATA.polos : DATA.zips; }
  function isFree(i) { return i >= NEED; }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function byHandle(list, h) {
    for (var i = 0; i < list.length; i++) { if (list[i].handle === h) { return list[i]; } }
    return null;
  }

  function slotHtml(i) {
    var label = isFree(i) ? COPY.freeLabel : 'POLO ' + (i + 1);
    var tag = isFree(i) ? '<span class="gw-slot__free">FREE</span>' : '';
    var items = pool(i).map(function (p) {
      var dis = p.available ? '' : ' disabled';
      var oos = p.available ? '' : '<span class="gw-pick__oos">SOLD OUT</span>';
      return '<button type="button" class="gw-pick" data-gw-pick="' + esc(p.handle) + '"' + dis +
        ' aria-pressed="false" title="' + esc(p.title) + '">' +
        '<span class="gw-pick__media">' + oos +
        mediaHtml(p) +
        '</span><span class="gw-pick__name">' + esc(p.title) + '</span></button>';
    }).join('');
    return '<section class="gw-slot" data-gw-slot="' + i + '">' +
      '<div class="gw-slot__head"><span class="gw-slot__num">' + (i + 1) + '</span>' +
      '<h3 class="gw-slot__title">' + label + '</h3>' + tag +
      '<p class="gw-slot__status" data-gw-slot-status>Choose one</p></div>' +
      '<div class="gw-picks" role="group" aria-label="' + esc(label) + '">' + items + '</div>' +
      '<div class="gw-sizes" data-gw-sizes hidden></div>' +
      '<input type="hidden" name="items[' + i + '][id]" data-gw-input-id>' +
      '<input type="hidden" name="items[' + i + '][quantity]" value="1">' +
      '</section>';
  }

  slotsEl.innerHTML = Array.from({ length: TOTAL_SLOTS }, function (_, i) { return slotHtml(i); }).join('');

  /* Tier bar: one filling segment per step, labelled. The LAST tier is the reward — the operator
     wants the free polo + free shipping presented as what the final step unlocks, not something
     granted halfway. Labels come from a setting, and a missing one falls back to the step number
     so a changed polo_qty can never render a blank tier. */
  var tiersEl = root.querySelector('[data-gw-tiers]');
  if (tiersEl) {
    tiersEl.innerHTML = Array.from({ length: TOTAL_SLOTS }, function (_, i) {
      var last = i === TOTAL_SLOTS - 1;
      var label = COPY.tiers[i] || ('Step ' + (i + 1));
      return '<li class="gw-tier' + (last ? ' gw-tier--reward' : '') + '" data-gw-tier="' + i + '">' +
        '<span class="gw-tier__bar"><i></i></span>' +
        '<span class="gw-tier__label">' + esc(label) + '</span></li>';
    }).join('');
  }

  function renderSizes(i) {
    var slot = slotsEl.querySelector('[data-gw-slot="' + i + '"]');
    var box = slot.querySelector('[data-gw-sizes]');
    var pick = picks[i];
    if (!pick) { box.hidden = true; box.innerHTML = ''; return; }
    var p = byHandle(pool(i), pick.handle);
    if (!p) { box.hidden = true; return; }
    /* A product with one nameless variant has no size to choose — do not render an empty row. */
    var single = p.variants.length === 1 && /default/i.test(p.variants[0].title);
    if (single) { box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    box.innerHTML = '<p class="gw-sizes__label">SIZE</p>' + p.variants.map(function (v) {
      var on = pick.variantId === v.id;
      return '<button type="button" class="gw-size' + (on ? ' is-on' : '') + '" data-gw-size="' + v.id + '"' +
        (v.available ? '' : ' disabled') + ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
        esc(v.title) + '</button>';
    }).join('');
  }

  function complete(i) { return picks[i] && picks[i].variantId; }
  function doneCount() {
    var n = 0;
    for (var i = 0; i < TOTAL_SLOTS; i++) { if (complete(i)) { n++; } }
    return n;
  }

  function render() {
    for (var i = 0; i < TOTAL_SLOTS; i++) {
      var slot = slotsEl.querySelector('[data-gw-slot="' + i + '"]');
      var pick = picks[i];
      Array.prototype.forEach.call(slot.querySelectorAll('[data-gw-pick]'), function (b) {
        var on = pick && b.getAttribute('data-gw-pick') === pick.handle;
        b.classList.toggle('is-on', !!on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var st = slot.querySelector('[data-gw-slot-status]');
      var p = pick ? byHandle(pool(i), pick.handle) : null;
      st.textContent = !pick ? 'Choose one'
        : (complete(i) ? p.title + (pick.size ? ' · ' + pick.size : '') : 'Pick a size');
      slot.classList.toggle('is-done', !!complete(i));
      slot.querySelector('[data-gw-input-id]').value = complete(i) ? pick.variantId : '';
    }

    var n = doneCount();
    var polosDone = 0;
    for (var j = 0; j < NEED; j++) { if (complete(j)) { polosDone++; } }
    var unlocked = polosDone >= NEED;

    if (tiersEl) {
      Array.prototype.forEach.call(tiersEl.children, function (li, i) {
        li.classList.toggle('is-reached', n >= i + 1);
        li.classList.toggle('is-next', n === i);
      });
    }
    root.querySelector('[data-gw-meter-count]').textContent = n + ' / ' + TOTAL_SLOTS;
    var copy = root.querySelector('[data-gw-meter-copy]');
    if (unlocked && n === TOTAL_SLOTS) { copy.textContent = COPY.done; }
    else if (unlocked) { copy.textContent = COPY.mid; }
    else { copy.textContent = COPY.start; }
    root.classList.toggle('is-unlocked', unlocked);

    /* summary */
    var list = root.querySelector('[data-gw-sum-list]');
    var total = 0, saving = 0;
    list.innerHTML = Array.from({ length: TOTAL_SLOTS }, function (_, i) {
      var pk = picks[i];
      var prod = pk ? byHandle(pool(i), pk.handle) : null;
      var label = isFree(i) ? COPY.freeShort : 'Polo ' + (i + 1);
      if (!prod || !complete(i)) {
        return '<li class="gw-bundle__sum-row is-empty"><span>' + label + '</span><span>—</span></li>';
      }
      if (isFree(i)) { saving += prod.price; } else { total += prod.price; }
      return '<li class="gw-bundle__sum-row"><span>' + esc(prod.title) +
        (pk.size ? ' <i>' + esc(pk.size) + '</i>' : '') + '</span><span>' +
        (isFree(i) ? '<s>' + money(prod.price) + '</s> FREE' : money(prod.price)) + '</span></li>';
    }).join('');
    root.querySelector('[data-gw-total]').textContent = total ? money(total) : '—';
    var sv = root.querySelector('[data-gw-saving]');
    sv.hidden = saving === 0;
    sv.textContent = saving ? 'You save ' + money(saving) : '';

    var ready = n === TOTAL_SLOTS;
    submit.disabled = !ready;
    submit.textContent = ready ? COPY.ctaReady : COPY.ctaIncomplete;
  }

  /* Any pick clears a leftover note — "Bundle added" must never linger over a fresh selection
     and make the builder look finished. */
  function clearNote() {
    msg.hidden = true;
    msg.textContent = '';
    msg.classList.remove('is-ok');
  }

  var justAdded = false;

  /* The cart is the source of truth for whether the offer still holds. Removing one polo silently
     revokes the BXGY and the "free" zip quietly goes back to full price, so say so and invite a
     rebuild rather than leaving the shopper to notice at checkout. */
  document.addEventListener('gw:cart:changed', function (ev) {
    var items = (ev.detail && ev.detail.items) || [];
    if (justAdded) { justAdded = false; return; }   /* the add itself is not a "change" */
    var poloH = DATA.polos.map(function (p) { return p.handle; });
    var zipH = DATA.zips.map(function (p) { return p.handle; });
    var polos = 0, zips = 0;
    items.forEach(function (l) {
      if (poloH.indexOf(l.handle) > -1) { polos += l.quantity; }
      if (zipH.indexOf(l.handle) > -1) { zips += l.quantity; }
    });
    if (zips > 0 && polos < NEED) {
      msg.hidden = false;
      msg.classList.remove('is-ok');
      msg.textContent = COPY.freeShort + ' is no longer free — a bundle needs ' + NEED +
        ' polos. Build another below.';
    } else if (msg.classList.contains('is-ok')) {
      clearNote();
    }
  });

  /* keep the active dot in step with the strip; scroll does not bubble, so capture it */
  slotsEl.addEventListener('scroll', function (ev) {
    var t = ev.target;
    if (!t.hasAttribute || !t.hasAttribute('data-gw-track')) { return; }
    var k = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
    Array.prototype.forEach.call(t.parentNode.querySelectorAll('[data-gw-dot]'), function (d, j) {
      d.classList.toggle('is-on', j === k);
    });
  }, true);

  slotsEl.addEventListener('click', function (ev) {
    /* a tapped dot pages the photos (mouse users have no swipe) and does NOT pick the product */
    var dot = ev.target.closest('[data-gw-dot]');
    if (dot) {
      ev.preventDefault();
      var track = dot.closest('.gw-pick__media').querySelector('[data-gw-track]');
      track.scrollTo({ left: track.clientWidth * parseInt(dot.getAttribute('data-gw-dot'), 10), behavior: 'smooth' });
      return;
    }
    var pickBtn = ev.target.closest('[data-gw-pick]');
    var sizeBtn = ev.target.closest('[data-gw-size]');
    if (!pickBtn && !sizeBtn) { return; }
    var slot = ev.target.closest('[data-gw-slot]');
    var i = parseInt(slot.getAttribute('data-gw-slot'), 10);

    if (pickBtn) {
      if (pickBtn.disabled) { return; }
      clearNote();
      var handle = pickBtn.getAttribute('data-gw-pick');
      var p = byHandle(pool(i), handle);
      picks[i] = { handle: handle, variantId: null, size: null };
      /* a single nameless variant needs no size step — select it outright */
      if (p.variants.length === 1 && /default/i.test(p.variants[0].title) && p.variants[0].available) {
        picks[i].variantId = p.variants[0].id;
      }
      renderSizes(i);
      render();
      return;
    }

    if (sizeBtn.disabled) { return; }
    clearNote();
    var id = parseInt(sizeBtn.getAttribute('data-gw-size'), 10);
    var prod = byHandle(pool(i), picks[i].handle);
    var v = prod.variants.filter(function (x) { return x.id === id; })[0];
    picks[i].variantId = id;
    picks[i].size = v ? v.title : null;
    renderSizes(i);
    render();
  });

  form.addEventListener('submit', function (ev) {
    if (doneCount() !== TOTAL_SLOTS) { return; }         /* let the browser block it */
    ev.preventDefault();
    submit.disabled = true;
    var prev = submit.textContent;
    submit.textContent = 'ADDING…';
    msg.hidden = true;

    var items = picks.map(function (p) { return { id: p.variantId, quantity: 1 }; });
    fetch(ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) {
        /* Shopify answers a throttled storefront with 429 and an HTML holding page, so r.json()
           threw and the raw "Unexpected token '<'" leaked into the shopper-facing message.
           Read as text and only then attempt JSON. */
        if (r.status === 429) {
          throw new Error('Too many requests right now. Give it a moment and try again.');
        }
        return r.text().then(function (t) {
          var j = null;
          try { j = JSON.parse(t); } catch (e) { j = null; }
          throw new Error((j && (j.description || j.message)) || 'Could not add to cart. Please try again.');
        });
      }
      /* Open the site's own drawer rather than navigating away — the shopper keeps their place
         on the page. gw-v2.js re-reads /cart.js on this event, so the drawer cannot show stale
         lines, and it falls back to the cart page if that fetch fails. If the drawer is not on
         the page at all (a template without it), navigate as before. */
      if (document.querySelector('[data-gw-cart]')) {
        justAdded = true;
        document.dispatchEvent(new CustomEvent('gw:cart:refresh'));
        picks = new Array(TOTAL_SLOTS).fill(null);
        for (var k = 0; k < TOTAL_SLOTS; k++) { renderSizes(k); }
        render();
        submit.disabled = true;
        submit.textContent = COPY.ctaIncomplete;
        msg.hidden = false;
        msg.classList.add('is-ok');
        msg.textContent = 'Bundle added to your cart.';
      } else {
        window.location.href = CART_URL;
      }
    }).catch(function (err) {
      submit.disabled = false;
      submit.textContent = prev;
      msg.hidden = false;
      msg.classList.remove('is-ok');
      var m = err && err.message ? err.message : '';
      /* a network-level failure (offline, blocked, challenged) surfaces as "Failed to fetch" */
      if (!m || /failed to fetch|networkerror|load failed/i.test(m)) {
        m = 'Could not reach the cart. Check your connection and try again.';
      }
      msg.textContent = m;
    });
  });

  render();
})();
